import { render, staticRenderFns } from "./ComplaintAffairs.vue?vue&type=template&id=e244ab9a&scoped=true&"
import script from "./ComplaintAffairs.vue?vue&type=script&lang=js&"
export * from "./ComplaintAffairs.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintAffairs.vue?vue&type=style&index=0&id=e244ab9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e244ab9a",
  null
  
)

export default component.exports